export default __webpack_public_path__ + "static/manchester_overlay-517fb79915f4db123d8712198fdc8575.png";